import axios from 'axios'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getAttachmentIcon, getErrorMessageByStatusCode } from '../../util/utilityFunction'
import useLoadingStore from '../../stores/useLoadingStore'
import ConfigAPI from '../../constant/ConfigAPI'

const useContent = () => {
    const [data, setData] = useState<CMSContentType>()
    const [noDataMessage, setNoDataMessage] = useState<string>('')
    const [isDataNotFound, setIsDataNotFound] = useState<boolean>(false)
    const loadingStore = useLoadingStore()
    const { t } = useTranslation()

    const getContentServiceName = (id: number) => {
        switch (id) {
            case 2: // ข้อมูลช่องรายการ
                return 'channels'
            case 3: // วิธีการติดตั้ง และรับชม
                return 'howto'
            case 4: // แผนการขยายโครงข่ายฯ
                return 'plan'
            case 8: // ช่วยเหลือ
                return 'help'
            default:
                return ''
        }
    }

    const getMenuName = (id: number) => {
        switch (id) {
            case 2: // ข้อมูลช่องรายการ
                return t('MENU.CHANNEL')
            case 3: // วิธีการติดตั้ง และรับชม
                return t('MENU.GUIDANCE')
            case 4: // แผนการขยายโครงข่ายฯ
                return t('MENU.NETWORK')
            case 8: // ช่วยเหลือ
                return t('MENU.HELP')
            default:
                return ''
        }
    }

    const callServiceGetContent = async (menuId: number) => {
        try {
            loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/content/${getContentServiceName(menuId)}`
            const result = await axios.get(url, ConfigAPI)

            if (result.data) {
                const { title, body, coverImageUrl, externalLinks, pdfLinks, pictures, versionDateTime } = result.data

                setNoDataMessage('')
                setIsDataNotFound(false)
                setData({
                    ...result.data,
                    pdfLinks: pdfLinks?.map((item: FileType) => ({
                        ...item,
                        icon: getAttachmentIcon(item.urlPath || ''),
                    })),
                })

                if (
                    !body &&
                    (!externalLinks || externalLinks.length === 0) &&
                    (!pdfLinks || pdfLinks.length === 0) &&
                    (!pictures || pictures.length === 0)
                ) {
                    if (!coverImageUrl) {
                        setIsDataNotFound(true)
                        setNoDataMessage('ไม่มีแผนการดำเนินการ')
                    } else {
                        setNoDataMessage('อยู่ระหว่างการปรับปรุงเนื้อหา')
                    }
                }
            }

            return { result }
        } catch (error) {
            if (error) {
                //@ts-ignore
                const errMsg: string = error?.toString()
                if (errMsg) {
                    if (errMsg.includes('404')) {
                        setNoDataMessage('ไม่มีแผนการดำเนินการ')
                    } else {
                        setNoDataMessage(getErrorMessageByStatusCode(errMsg, getMenuName(menuId)))
                    }
                    setIsDataNotFound(true)
                }
            }
            return { error }
        } finally {
            loadingStore.setLoading(false)
        }
    }

    return {
        data,
        noDataMessage,
        isDataNotFound,
        callServiceGetContent,
    }
}

export default useContent
